/**
 * Engine state (ADR-019, ADR-021): the bot's user document plus the
 * in-progress interactions that the bot keeps in memory (an adventure run,
 * a Spot round). Only `user` is ever stored; `session` lives in the web
 * server's memory per account and a restart ends it, as a bot restart does.
 */
import type { BotUser, EquipedSlot, OwnedEntry, QuestTrackingPeriod, SummonedCategory, EpochMs } from './bot/user.js';
import type { AdventureRun } from './systems/adventures/types.js';

export type { BotUser, SummonedCategory };
/** One owned item: `{ id, level, total, current }` (total = ever obtained, current = unspent duplicates). */
export type OwnedItem = OwnedEntry;
/** One team row; 0 = empty. */
export type TeamSlot = EquipedSlot;
/** Quest counters of one period (`stats.quest.daily|weekly`). */
export type QuestPeriod = QuestTrackingPeriod<EpochMs>;

/** A Spot game in progress (`minigames/spot.ts`): the bid is charged when it ends. */
export interface SpotRound {
  bid: number;
  round: number;
}

/** What only exists while the player is acting (ADR-021). Never written to Firestore. */
export interface Session {
  run: AdventureRun | null;
  spot: SpotRound | null;
}

export interface GameState {
  user: BotUser;
  session: Session;
}

export function emptySession(): Session {
  return { run: null, spot: null };
}

export function gameState(user: BotUser, session: Session = emptySession()): GameState {
  return { user, session };
}
